    
  import { gsap } from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";


    gsap.registerPlugin(ScrollTrigger);

    // Animate text fade-in on scroll
    const tl = gsap.timeline();

    tl.to(".hero-top", {
      y: 0,
      opacity: 1,
      duration: 1.2,
      ease: "power2.inOut"
    })
    .to(".hero-sub", {
      y: 0,
      opacity: 1,
      duration: 1.2,
      ease: "power2.inOut",
    });







